export default "__VITE_ASSET__Br02NH_c__"